module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/id_2-d603c1efe346bc709e7f66e68454afaf.jpg";